import { useApi } from "lib/apiFetcher";

export const useBlogArticlesApi = () => useApi("get", "/blog");
export const useBlogArticleDetailApi = (additionalKey: string) =>
  useApi("get", "/blog/{slug}", additionalKey);
